




























import { Component, Vue } from 'vue-property-decorator';
import Title from '@/components/Title.vue';
import WechatReport from '@/components/reports/DailyWechatReport.vue';
import ReportDate from '@/components/reports/DailyReportDate.vue';
import LevelMixin from '@/mixins/dailyWechatReport.mixin';

@Component({
  components: { 
    Title, 
    WechatReport, 
    ReportDate 
  },
  mixins: [LevelMixin]
})
export default class DWReport extends Vue {}
